import { styled } from '@clickcease/cc-client-components-lib'

export const GetTagContainer = styled('div', {
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'flex-start',
  width: '740px',
  minHeight: '601px',
})

export const MethodSelectorContainer = styled('div', {
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  marginTop: '$8',
})

export const InstructionSection = styled('div', {
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'flex-start',
  height: '100%',
  width: '100%',
})

export const MethodsBar = styled('div', {
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
  justifyContent: 'center',
  marginTop: '$8',
  gap: '$10',
})

export const MethodContainer = styled('div', {
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'space-between',
  width: '130px',
  height: '74px',
  padding: '$10',
  borderRadius: '12px',
  border: '1px solid transparent',
  boxShadow: '0px 5px 20px 0px rgba(102, 102, 102, 0.15)',

  '&:hover': {
    border: '1px solid $primaryColor',
    cursor: 'pointer',
  },

  variants: {
    selected: {
      true: {
        border: '1px solid $primaryColor',
        backgroundColor: '$tableSelected',
        ['svg']: {
          color: '$primaryColor',
        },
      },
    },
    isSmall: {
      true: {
        width: '136px',
        height: '52px',
        padding: '$8 $6',
      },
    },
  },
})

export const TagInstallationFooter = styled('div', {
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
  justifyContent: 'space-between',
  width: '100%',
  marginTop: '$6',
  marginBottom: '$2',
})
